import React from "react";
import styled from "@emotion/styled";

import AreaTypes from "types/AreaTypes";
import PointTypes from "types/PointTypes";
import PathTypes from "types/PathTypes";

import Chip from "@mui/material/Chip";

import ParkkiTheme from "themes/ParkkiTheme";

const StyledChip = styled(Chip)`
  cursor: pointer;
  margin-right: ${ParkkiTheme.spacings.teeny};
  margin-top: ${ParkkiTheme.spacings.teeny};
`;

type Props = {
  layers: AreaTypes[] | PointTypes[] | PathTypes[];
  onSelectLayers: Function;
};

function UnselectedChips({ layers, onSelectLayers }: Props): JSX.Element {
  function handleSelectLayer(
    layerToSelect: AreaTypes | PointTypes | PathTypes
  ) {
    const newlySelectedLayers = [
      // @ts-ignore
      ...layers.filter((layer) => layer.selected),
      layerToSelect,
    ];

    return onSelectLayers(newlySelectedLayers);
  }

  return (
    <>
      {layers
        // @ts-ignore
        .filter((layer) => !layer.selected)
        .map((layer: AreaTypes | PointTypes | PathTypes, index: number) => (
          <StyledChip
            key={index}
            size="small"
            label={layer.short_name || layer.long_name || layer.id}
            onClick={() => handleSelectLayer(layer)}
          />
        ))}
    </>
  );
}

export default UnselectedChips;
